import React from "react";

import Header from "../../components/Header";
import Footer from "../../components/Footer";
import GlobalCta from "../../components/global/GlobalCta";
import PageHero from "../../components/global/PageHero";
import ServiceOverview from "../../components/global/ServiceOverview";
import ServiceFeatures from "../../components/global/ServiceFeatures";
import ServiceChecks from "../../components/global/ServiceChecks";

const OVERVIEW = [
    "Our VSA (virtual system administrator) services give you senior sysadmin expertise remotely, whenever you need it — without a full-time hire.",
    "We handle configuration, tuning, troubleshooting and day-to-day administration across your servers and services, acting as your remote operations team.",
];

const FEATURES = [
    { title: "Senior expertise on demand", text: "Experienced administrators available without the full-time cost." },
    { title: "Remote administration", text: "Systems configured, tuned and maintained wherever they live." },
    { title: "Troubleshooting", text: "Fast diagnosis and resolution of server and network issues." },
    { title: "Flexible engagement", text: "Scale support up or down as your needs change." },
];

const CHECKS = [
    "Remote system administration",
    "Configuration & tuning",
    "Troubleshooting & support",
    "User & access management",
    "Ongoing maintenance",
];

export default function VsaServices() {
    return (
        <>
            <Header />

            <main>
                <PageHero eyebrow="Server & Networking" title="VSA Services" eyebrowAs="span">
                    Virtual system administration on demand — expert hands to run, tune and troubleshoot your systems remotely.
                </PageHero>
                <ServiceOverview paragraphs={OVERVIEW} />
                <ServiceFeatures items={FEATURES} />
                <ServiceChecks title="What's included" items={CHECKS} />
            </main>

            <GlobalCta />

            <Footer />
        </>
    );
}
